export default "__VITE_ASSET__5_X9z5eq__"